export default {
	path: '/',
	icon: '',
	meta: {
		title: '开疆工具箱'
	},
	children: [
		{
			path: '/KJ/tools',
			name: 'AppIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/tools'),
			meta: {
				title: '应用管理'
			}
		},

		{
			path: '/KJ/material',
			name: 'MaterialIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/material'),
			meta: {
				title: '宣传资料'
			}
		},

		{
			path: '/KJ/paymentQRCode',
			name: 'PaymentQRCodeIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/paymentQRCode'),
			meta: {
				title: '支付二维码'
			}
		},
		{
			path: '/KJ/postManagement',
			name: 'PostManagementIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/postManagement'),
			meta: {
				title: '岗位管理'
			}
		},
		{
			path: '/KJ/applicationInquiry',
			name: 'ApplicationInquiryIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/applicationInquiry'),
			meta: {
				title: '报考查询'
			}
		},
		{
			path: '/KJ/invoiceHead',
			name: 'InvoiceTitleIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/invoiceTitle'),
			meta: {
				title: '发票抬头'
			}
		}
	]
}
